<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <!-- <input
          type="file"
          id="xlsFile"
          accept=".xls,.xlsx"
          @change="importData($event)"
        /> -->
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="add"
          >新增</el-button
        >
      </div>
      <div class="search_box"></div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column
            prop="id"
            label="编号"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="designation"
            label="制度建设资料名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="docAddress"
            label="制度建设资料地址"
            align="center"
          >
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template v-slot="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="$Common.fileDownloads(scope.row.docAddress)"
                >下载</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="del(scope.row)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div> -->
    </div>
    <risk-add :resize="resize" @getList="getList"></risk-add>
  </div>
</template>

<script>
import RiskAdd from "./components/RiskInstitutionalBuildingAdd.vue";
export default {
  name: "RiskInstitutionalBuilding",
  components: {
    RiskAdd
  },
  props: {},
  data() {
    return {
      // 请求数据
      searchData: {
        schoolId: this.$store.state.schoolId
      },
      tableData: [],
      total: 0,
      resize: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.searchData.pageNum = val;
      this.getList();
    },
    add() {
      this.resize++;
    },
    del(item) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delInstitutionalBuilding(item);
        })
        .catch(() => {});
    },
    async delInstitutionalBuilding(item) {
      let req = {
        id: item.id,
        docAddress: item.docAddress
      };
      let res = await this.$Http.delInstitutionalBuilding(req, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getList() {
      let res = await this.$Http.getInstitutionalBuilding(this.searchData);
      if (res.code == 200) {
        this.tableData = res.data || [];
      } else if (res.code == 101) {
        this.total = 0;
        this.tableData = [];
      } else {
        this.total = 0;
        this.tableData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {
    this.getList();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped></style>
